import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  variants: {
    placement: {
      start: {
        '& svg': {
          boxSize: 6,
          color: 'primary.500',
        },
      },
      end: {
        pointerEvents: 'auto',
        '& svg': {
          boxSize: 6,
          color: 'primary.500',
        },
      },
    },
  },
});
